import { render, staticRenderFns } from "./OrderCustomerCard.vue?vue&type=template&id=6ca45fb3&scoped=true"
import script from "./OrderCustomerCard.vue?vue&type=script&lang=js"
export * from "./OrderCustomerCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomerCard.vue?vue&type=style&index=0&id=6ca45fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca45fb3",
  null
  
)

export default component.exports